<template>
  <div
    style="
      margin-bottom: 50px;
      margin-top: 50px;
      text-align: center;
      font-size: 14px;
    "
  >
    Copyright © {{ new Date().getFullYear() }} © Copyright NYCU CSIT. All Rights
    Reserved.
  </div>
</template>
<script>
export default {
  name: "judge-footer",
  props: {
    title: String,
    test: String,
  },
};
</script>
